<template>
    <el-dialog :title="ownerData.Id ? 'Edit Owner' : 'Add Owner'"
               closeable
               :visible.sync="value"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="$emit('input', false)"
               width="50%"
    >
        <el-form label-width="140px" size="medium" width="400px">
            <el-form-item label="First Name">
                <el-input v-model="ownerData.FirstName"/>
            </el-form-item>
            <el-form-item label="Last Name">
                <el-input v-model="ownerData.LastName"/>
            </el-form-item>
            <el-form-item label="Email">
                <el-input v-model="ownerData.Email"/>
            </el-form-item>
            <el-form-item label="Alternate Email">
                <el-input v-model="ownerData.AlternateEmail"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">Submit</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import ApiService from "../utils/ApiService";

export default {
    name: "DialogEditRentalOwner",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        owner: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            ownerData: {
                Id: null,
                Email: null,
                AlternateEmail: null,
                FirstName: null,
                LastName: null,
                Type: 'Custom'
            }
        }
    },
    watch: {
        owner(newVal, oldVal) {
            console.log(newVal, oldVal);
            this.ownerData = {
                ...this.ownerData,
                ...newVal
            };
        }
    },
    methods: {
        submit() {
            let {Id} = this.ownerData;
            if (Id) {
                ApiService.put('/buildium/rentals/owners/' + Id, this.ownerData).then(response => {
                    this.$message.success('Owner Updated!');
                    this.$emit('update', response);
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            } else {
                ApiService.post('/buildium/rentals/owners', this.ownerData).then(response => {
                    this.$message.success('Owner Saved!');
                    this.$emit('update', response);
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            }
        }
    }
}
</script>

<style scoped>

</style>